import React, { useState } from 'react';
import { LocationFilterType } from '../../../helpers/Enums';

type LocationFilterProps = {
    locationFilter: LocationFilterType;
    setLocationFilter: (locationFilter: LocationFilterType) => void;
}

const LocationFilter = ({ setLocationFilter, locationFilter }: LocationFilterProps) => {
    return (
        <div style={{ width: '100%' }}>
            <div className="field_block">
                <select className="txt_field age w-select" value={locationFilter} onChange={(e: any) => setLocationFilter(e.target.value)}>
                    <option value={LocationFilterType.Country}>מכל הארץ</option>
                    <option value={LocationFilterType.MyArea}>מהאזור שלי</option>
                    <option value={LocationFilterType.MyCity}>מהישוב שלי</option>
                </select>
                <div className="form_allert">----------------------------</div>
            </div>
        </div>
    )
}

export default LocationFilter;